import React, { createContext, useContext, useState, useEffect } from 'react';

import { obtenerProductos } from '../services/tiendaOnline'; // Importar servicios
import { getProductosFromStorage, saveProductosToStorage } from '../utils/productosStorage';
import { obtenerUsuario } from '../auth/index';

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const usuario = obtenerUsuario();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [lastFetch, setLastFetch] = useState(null);

    const fetchProducts = async () => {
        // Si los datos son recientes (menos de 5 minutos) y no se fuerza refresco, no cargar
        // if (!forceRefresh && lastFetch && (Date.now() - lastFetch < 3 * 60 * 1000)) {
        //     console.log('Cargando productos desde el estado local, no es necesario refrescar');
        //     return;
        // }

        setLoading(true);
        try {
            const response = await obtenerProductos({ id_usuario: usuario.id });

            if (!response.status) {
                throw new Error('Error al cargar productos');
            }

            setProducts(response.data);
            setLastFetch(Date.now());
            saveProductosToStorage(response.data); // Guardar productos en localStorage
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Función para obtener un producto por ID
    const getProductById = (id) => {
        return products.find(product => product.id_producto === Number(id));
    };

    // Carga inicial
    useEffect(() => {
        // Intentar cargar productos desde localStorage primero
        setLoading(true);
        const storedProducts = getProductosFromStorage();
        if (storedProducts) {
            // console.log('Cargando productos desde localStorage:', storedProducts);
            setProducts(storedProducts);
            setLastFetch(Date.now());
        }
        // Luego, cargar desde el servidor
        if (!storedProducts || storedProducts.length === 0) {
            fetchProducts();
        }

        setLoading(false);
    }, []);

    // Refrescar productos cada 60 minutos
    useEffect(() => {
        const interval = setInterval(() => {
            fetchProducts();
        }, 3 * 60 * 1000); // 3 minutos

        return () => clearInterval(interval);

    }, [lastFetch]);

    const clearProducts = () => {
        setProducts([]);
        setLastFetch(null);
        setError(null);
        saveProductosToStorage([]); // Limpiar localStorage
    };

    return (
        <ProductContext.Provider value={{
            products,
            loading,
            error,
            getProductById,
            refreshProducts: () => fetchProducts(true),
            clearProducts
        }}>
            {children}
        </ProductContext.Provider>
    );
};

export const useProducts = () => {
    const context = useContext(ProductContext);
    if (!context) {
        throw new Error('useProducts debe usarse dentro de un ProductProvider');
    }
    return context;
};